import { Field, useFormikContext } from 'formik';
import { useCallback } from 'react';
import { Grid, Typography } from '@mui/material';
import MuiValidTextField from 'src/components/input/MuiValidTextField';
import useFetchAddressByZip from 'src/services/useFetchAddressByZip';

export default function BusinessInfoAddress({
  label = '',
  cityFieldName = '',
  zipFieldName = '',
  streetFieldName = '',
}) {
  const { setFieldValue } = useFormikContext();
  const fetchAddressByZip = useFetchAddressByZip();

  const handleZipChange = useCallback(
    async (event) => {
      const address = await fetchAddressByZip(event.target.value);
      if (address) {
        setFieldValue(cityFieldName, formatCityState(address.city, address.state));
      }
    },
    [fetchAddressByZip, setFieldValue, cityFieldName]
  );

  function formatCityState(city, state) {
    return `${city}, ${state}`;
  }

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={12}>
        <Typography className="app-title" variant="h6" sx={{ color: 'black' }}>
          {label}
        </Typography>
      </Grid>
      <Grid item xs={12} md={6}>
        <Field
          name={streetFieldName}
          component={MuiValidTextField}
          label={'Address'}
          sx={{ width: '100%' }}
          variant="standard"
          inputProps={{ maxLength: 40 }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <Field
          name={cityFieldName}
          component={MuiValidTextField}
          label={'City, State'}
          sx={{ width: '100%' }}
          variant="standard"
          inputProps={{ maxLength: 40 }}
        />
      </Grid>
      <Grid item xs={12} md={2}>
        <Field
          name={zipFieldName}
          component={MuiValidTextField}
          label={'Zip'}
          sx={{ width: '100%' }}
          variant="standard"
          inputProps={{ maxLength: 5 }}
          onInput={handleZipChange}
        />
      </Grid>
    </Grid>
  );
}
